import { ArticleMeta, articleTag } from "./types";

const META: ArticleMeta = {
    slug: "vulkan-compute-pipelines",
    section: "briefing",
    header: "GPU Engineering",
    title: "Vulkan Compute Pipelines",
    description: "Descriptor sets, async queues, and memory barriers tuned for real throughput.",
    tags: [
        articleTag("nvidea.svg"),
        articleTag("cpp.svg"),
        articleTag("vulkan-svgrepo-com.svg"),
        articleTag("opengl-svgrepo-com.svg"),
        articleTag("blender-svgrepo-com.svg"),
    ],
    url: "/articles/vulkan-compute-pipelines",
};

export default META;
